import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Card, CardContent } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Popover from "@material-ui/core/Popover";
import "./collection.css";
import { withRouter } from "react-router-dom";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { GenericLoader } from "../../../shared/widgets";
import { templateStrings, amountFields } from "../../../Constant";
import { indianNSConverter } from "../../../shared/methods/indianNSConverter";

const styles = {
  root: {
    height: "100%",
  },
  cardWrapper: {
    borderRadius: "0px",
  },
  cardContentWrapper: {
    paddingBottom: "16px !important",
  },
  popOverClass: {
    borderRadius: "none",
  },
};

const getValueStyle = (value, column, isWithUnits) => {
  const clonedValue = value && value.toLocaleString(undefined, { maximumFractionDigits: 2 });
  if (amountFields[`${column}`] !== undefined) {
    return isWithUnits ? `₹ ${indianNSConverter(value)}` : `₹ ${clonedValue}`;
  }
  return clonedValue !== null ? clonedValue : "-";
};

class GridList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pop_open: false,
    };
    this.handleOpenPopUp = this.handleOpenPopUp.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpenPopUp(e) {
    const { pop_open: popOpen } = this.state;
    e.preventDefault();
    this.setState({
      pop_open: !popOpen,
      anchorEl: e.currentTarget,
    });
  }

  handleClose() {
    this.setState({
      pop_open: false,
    });
  }

  navigate = () => {
    const { history } = this.props;
    history.push("/collection/card-collection");
  };

  render() {
    const {
      classes, template, type, value, gridItemsData = "", isLoading = false,
    } = this.props;
    const { pop_open: popOpen, anchorEl } = this.state;
    const noOfThousands = Math.abs(value) / 1000;
    const gridStrings = templateStrings[type];
    const isExpandable = gridStrings[template].isExpandable
      && gridStrings[template].expandableType;
    // const expenseBreakDownStrings = templateStrings.expensesBreakdown;
    let breakDown = {
      other: 0,
      penalty: 0,
      fuelExpense: 0,
      associationFee: 0,
      maintenance: 0,
      helper: 0,
      conductorSalary: 0,
      tollAmount: 0,
      driverSalary: 0,
      cleaning: 0,
      totalRechargeCashAmt: 0,
      totalIssueCardCashAmt: 0,
      totalPassIssueCashAmt: 0,
      totalRechargeCardSold: 0,
      ticketByPrepaidCard: 0,
      mobileTicketResidualAmount: 0,
      upiTicketAmount: 0,
      mobileTicketAmount: 0,
      dailyPassAmount: 0,
      cardFee: 0,
      scanPayAmount: 0,
      chaloPayAmount: 0,
      ncmcPrepaidAmount: 0,
    };
    if (gridItemsData && gridItemsData.expenseBreakDown) {
      breakDown = gridItemsData.expenseBreakDown;
    }
    return (
      <Card
        onClick={
          gridStrings[template].navigationAllowed ? this.navigate : this.handleOpenPopUp
        }
        className={classes.cardWrapper}
      >
        <CardContent className={classes.cardContentWrapper}>
          <div className="text-icon-wrapper">
            <div className={`grid-title ${isExpandable && "pointer-cursor"}`}>
              {gridStrings[template].displayName}
            </div>
            {isExpandable && (
              <div>
                <span className="pointer-cursor">{popOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}</span>
                <Popover
                  className={{ root: classes.popOverClass }}
                  open={popOpen}
                  anchorEl={anchorEl}
                  onClose={this.handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <div className="expenseWrapper">
                    <div className="expenseWrapperTitle">Breakdown</div>
                    <div>
                      {Object.keys(templateStrings[gridStrings[template].expandableType]).map(
                        (column, index) => {
                          const breakDownStrings = templateStrings[
                            gridStrings[template].expandableType
                          ];
                          if (gridItemsData && gridItemsData.expenseBreakDown) {
                            breakDown = gridItemsData[`${template}BreakDown`];
                          }
                          return (
                            <div key={index} className="row-wrapper">
                              <div>{breakDownStrings[column]}</div>
                              <div>
                                {getValueStyle(breakDown[column], column)}
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  </div>
                </Popover>
              </div>
            )}
            {gridStrings[template] && gridStrings[template].navigationAllowed && (
              <div>
                <ChevronRightIcon />
              </div>
            )}
          </div>
          <div className="grid-content inr-unit pointer-cursor">
            {(isLoading && <GenericLoader />) || getValueStyle(value, template, true)}
          </div>
          {!isLoading
            && (
              <div className="display-flex flex-center margin-top-4 inr-value-wrap height-20">
                {(amountFields[template] !== undefined)
                && (
                  <span className="inr-value">
                    {noOfThousands >= 1 ? `Original Value: ${getValueStyle(value, template)}` : null}
                  </span>
                )}
              </div>
            )}
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(withRouter(GridList));
